/* Used for general purposes calls to get data across multiple collections */
import api from "./cofocusAPI";
import store from "../store";

export async function getInitialUserData(UID) {
  if (!UID) return { success: false, error: "Required data not provided for request." };

  /** Load and set timezone to display streak immediately on the calendar */
  const storedTimezone = localStorage.getItem("timezone");
  if (storedTimezone) {
    store.dispatch("userstats/setTimezone", JSON.parse(storedTimezone));
  }

  const response = await api.getResponseData({
    url: `api/userstats/${UID}`,
    method: "get",
    params: { UID },
    withCredentials: true,
  });

  if (!response || !response.success || !response.data) {
    throw new Error("Request failed to get initial user data.");
  }

  const userstats = response.data;
  /*   const styles = response.data.styles.styles; // NOTICE THE DOUBLE 'STYLES.STYLES'
  store.dispatch("style/setStyles", styles); */

  /* VALIDATE DATA */
  if (!userstats.sessionCount && userstats.sessionCount !== 0) throw new Error("User session count is missing");
  if (!userstats.hasBookedSession && userstats.hasBookedSession !== false) throw new Error("User hasBookedSession is missing.");
  if (!userstats.hasWatchedVideo && userstats.hasWatchedVideo !== false) throw new Error("User hasWatchedVideo is missing.");

  const { sessionCount, hasBookedSession, hasWatchedVideo } = userstats;
  const states = { sessionCount, hasBookedSession, hasWatchedVideo };

  /* SET DATA */
  await store.dispatch("userstats/setInitialCalendarLoadStats", userstats); /* Stats */
  store.dispatch("onboarding/setOnboardingStates", states);

  /* IF USER HAS NO TIMEZONE OR THEIR TIMEZONE HAS CHANGED, THEN GET THEIR TIMEZONE
   * AND SEND API REQUEST TO UPDATE IT & RECALCULATE STREAKS DATA. */
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!userstats.timezone || userstats.timezone !== timezone || !store.state.userstats || !store.state.userstats.timezone) {
    const timezoneResponse = await api.getResponseData({
      url: `api/userstats/${UID}/timezone`,
      method: "post",
      data: { UID, timezone },
      withCredentials: true,
    });
    if (!timezoneResponse.success || !timezoneResponse.streakData) {
      throw new Error("Failed to update user's timezone");
    }

    store.dispatch("userstats/updateUserStreakData", timezoneResponse.streakData);
  }

  /** Cache timezone to  be able to load streak immediately on the calendar */
  localStorage.setItem("timezone", JSON.stringify(userstats.timezone ?? timezone));
}

/**
 *
 * @param {String} UID User's ID
 * @param {String} item The item's content
 * @param {String} itemType The item's type, e.g. TASK, NOTE
 * @returns
 */
export async function createOneUserReport(report) {
  if (!report.UID || !report.section || !report.type || !report.category) return { success: false, error: "Required data not provided for request." };
  return api.getResponseData({
    url: `api/core/${report.UID}/report`,
    method: "post",
    data: report,
    withCredentials: true,
  });
}

/**
 * Sends one recorded error log to the server
 *
 * @param {Object} error The error log
 * @returns {Object} {success: Boolean}
 */
export async function logOneError(error) {
  if (!error) return { success: false, error: "Required data not provided for request." };
  return api.getResponseData({
    url: `api/core/error`,
    method: "post",
    data: {
      error,
    },
    withCredentials: true,
  });
}

/**
 * Uploads one image and returns its URL
 *
 * @param {String} UID User's ID
 * @param {Object} imageData An image's data
 * @returns {Object} {success: Boolean, imageData}
 */
export async function uploadOneImage(UID, fileData) {
  if (!UID || !fileData) return { success: false, error: "Required data not provided for request." };
  return api.getResponseData({
    url: `api/core/${UID}/image`,
    method: "post",
    data: fileData,
    withCredentials: true,
  });
}

/**
 * Uploads one image and returns its URL
 *
 * @param {String} UID User's ID
 * @param {Object} imageData An image's data
 * @returns {Object} {success: Boolean, imageData}
 */
export async function deleteOneImage(UID, fileId) {
  if (!UID || !fileId) return { success: false, error: "Required data not provided for request." };
  return api.getResponseData({
    url: `api/core/${UID}/deleteImage`,
    method: "post",
    data: { fileId },
    withCredentials: true,
  });
}

export default {
  getInitialUserData,
  createOneUserReport,
  logOneError,
  uploadOneImage,
  deleteOneImage,
};
